export default "__VITE_ASSET__Be$n4QPr__"